import store from '../../../store/SparePartsFinderFiltersBasketStore';
import Button from '../../common/Button';
import SparePartsFinderIndexTable from '../SparePartsFinderIndexTable';
import SparePartsFinderFiltersIndexTableRow from './SparePartsFinderFiltersIndexTableRow';

export default class SparePartsFinderFiltersIndexTable extends SparePartsFinderIndexTable {
    static defaultProps = {
        features: []
    }

    rowComponentClass = SparePartsFinderFiltersIndexTableRow;

    renderTableActions = () => (
        <React.Fragment>
            <h3>{__('Results')}</h3>
            <div className="index-table-button-actions">
                {store.hasAny() &&
                    <Button theme={Button.Theme.BorderOnly} onClick={this.onCartClick}>{__('Basket')}</Button>}
                {this.props.page.renderExportDropdown()}
            </div>
        </React.Fragment>
    )

    onCartClick() {
        store.setBasketIsOpen(true);
    }

    renderTableFoot() {
        const visiblePrice = this.props.page.getSelectedRowIds().length > 0;
        if (!visiblePrice) {
            return <React.Fragment/>
        }

        let colSpan = 1;
        let label = 'Total PPL'
        const totalNetPriceColumn = this.props.page.state.columns.find(x => x.slug === 'TotalNetPrice');
        if (totalNetPriceColumn && totalNetPriceColumn.visible) {
            colSpan = 4;
            label = 'Total net price'
        }

        return (
            <tfoot>
            <tr>
                <td colSpan={colSpan}></td>
                <td>{__(label)}</td>
                <td>{this.props.page.state.priceSummary.totalNetPrice}</td>
            </tr>
            </tfoot>
        )
    }
}
